import { render, staticRenderFns } from "./MealNutrientsMulti.vue?vue&type=template&id=166ff98c&scoped=true&"
import script from "./MealNutrientsMulti.vue?vue&type=script&lang=js&"
export * from "./MealNutrientsMulti.vue?vue&type=script&lang=js&"
import style0 from "./MealNutrientsMulti.vue?vue&type=style&index=0&id=166ff98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ff98c",
  null
  
)

export default component.exports